import React from "react";
import { SelectBox } from "devextreme-react/select-box";
import { StaffSelectBox } from "../../Shared/master";
import DateRangePicker from "../../Shared/DateRangePicker";

/**
 * Filters sent to CrewActivity/schedule-list: staff (active crew), airport, hotel (of the airport), check-in date range;
 * Search and Clear. filters = { employeeNumber, airportCode, hotelId, from, to }; onChange(partial).
 */
export default function CrewActivityFilterBar({ filters, airports, hotels, hotelsLoading, searching, onChange, onAirport, onSearch, onClear }) {
  return (
    <section className="dsp-filters cra-filters" aria-label="Filters">
      <div className="dsp-field cra-field--staff">
        <label>Staff</label>
        <StaffSelectBox activeOnly value={filters.employeeNumber || null} onChange={(employeeNumber) => onChange({ employeeNumber: employeeNumber || "" })} />
      </div>
      <div className="dsp-field cra-field--airport">
        <label>Airport</label>
        <SelectBox
          dataSource={airports}
          displayExpr="airportName"
          valueExpr="airportCode"
          value={filters.airportCode || null}
          placeholder="All airports"
          showClearButton
          searchEnabled
          inputAttr={{ "aria-label": "Airport" }}
          onValueChanged={(e) => onAirport(e.value ?? "")}
        />
      </div>
      <div className="dsp-field cra-field--hotel">
        <label>Hotel {hotelsLoading && <i className="fas fa-spinner fa-spin" aria-label="Loading hotels" />}</label>
        <SelectBox
          dataSource={hotels}
          displayExpr="hotelName"
          valueExpr="hotelId"
          value={filters.hotelId || null}
          placeholder="All hotels"
          showClearButton
          searchEnabled
          disabled={hotelsLoading}
          inputAttr={{ "aria-label": "Hotel" }}
          onValueChanged={(e) => onChange({ hotelId: e.value ?? 0 })}
        />
      </div>
      <div className="dsp-field dsp-field--date">
        <label>From - To date (check-in)</label>
        <DateRangePicker
          startDate={filters.from}
          endDate={filters.to}
          isClearable={false}
          ariaLabel="From - To date"
          onChange={([from, to]) => onChange({ from, to })}
        />
      </div>
      <div className="dsp-field dsp-field--action cra-actions">
        <button type="button" className="btn btn-primary btn-sm dsp-search" disabled={searching} onClick={onSearch}>
          <i className={`fas fa-${searching ? "spinner fa-spin" : "search"}`} aria-hidden="true" /> Search
        </button>
        <button type="button" className="btn btn-outline-secondary btn-sm dsp-search" onClick={onClear}>
          <i className="fas fa-eraser" aria-hidden="true" /> Clear
        </button>
      </div>
    </section>
  );
}
